module.exports = __webpack_public_path__ + "img/zelle_bg.4e1628b3.svg";